import { put, call, takeEvery, takeLatest } from 'redux-saga/effects';

import Actions from '../Actions/Creators';
import Types from '../Actions/Types';
import Phi from '../Phi/Phi';

import Constants from '../Phi/Constants'

function* fetchCountryList(action) {
    const response = yield call(Phi.Metadata.getMetaData, Phi.Metadata, {metaType: 'country'});

    if(Boolean(response) && !Boolean(response.error)) {
        yield put(Actions.responseCountryList({ok: true, data: response}));
    }
}



function* fetchStateList(action) {
    const params = {
        metaType: 'state',
        config: {countryId: action.countryId}
    };

    const response = yield call(Phi.Metadata.getMetaData, Phi.Metadata, params);

    if(Boolean(response) && !Boolean(response.error)) {
        yield put(Actions.responseStateList({ok: true, data: response}));
    }
}



function* fetchCityList(action) {
    const params = {
        metaType: 'city',
        config: {stateId: action.stateId}
    };

    const response = yield call(Phi.Metadata.getMetaData, Phi.Metadata, params);

    if(Boolean(response) && !Boolean(response.error)) {
        yield put(Actions.responseCityList({ok: true, data: response}));
    }
}



function* fetchPartnerList(action) {
    const response = yield call(Phi.Metadata.getMetaData, Phi.Metadata, {metaType: 'partners'});

    if(Boolean(response) && !Boolean(response.error)) {
        yield put(Actions.responsePartnerList({ok: true, data: response}));
    }
}



function* fetchSpecialityList(action) {
    const response = yield call(Phi.Metadata.getMetaData, Phi.Metadata, {metaType: 'specialities'});

    if(Boolean(response) && !Boolean(response.error)) {
        yield put(Actions.responseSpecialityList({ok: true, data: response}));
    }
}



function* fetchOffersList(action) {
    const response = yield call(Phi.Metadata.getMetaData, Phi.Metadata, {metaType: 'offers'});

    if(Boolean(response) && !Boolean(response.error)) {
        yield put(Actions.responseOffersList({ok: true, data: response}));
    }
}

function* getGlossary() {
    let response = [];
    try {
      response = yield call(Phi.Metadata.getGlossary, Phi.Metadata);
      if (Boolean(response)) {
        yield put(Actions.storeGlossary(response))
      }
    } catch (error) {
      yield put(Actions.storeGlossary(response, error))
    }
  }

  //to fetch all the doc for a contentId(school)
function* fetchDocuments(action) {
    yield put(Actions.setLoader())

    const { contentId, fileGroup } = action;
    const payload = {
        sourceNodeUUID: contentId,
        targetNodeUUID: null,
        relationType: null
    };

    if(!!contentId) {
        const response = yield call(Phi.Organization.getContentAssociation, Phi.Organization, payload);

        //update the store with the latest doc
        if (!(response && response.error)) {
            yield put(Actions.storeDocuments(response, fileGroup));
        }
    } else {
        yield put(Actions.storeDocuments([], fileGroup));
    }

    yield put(Actions.unsetLoader())
 
}
  
function* uploadDocuments(action) {
    yield put(Actions.setLoader())

    let { fileObj, contentId, category, fileGroup, fileCustom, uuid } = action;
    let docUploadSuccess
    let currentContentID = contentId
    //getting S3 credentials from S3 server

    fileCustom = fileCustom ? fileCustom : {}
    const s3Credentials = yield call(Phi.Organization.getS3Credentials, Phi.Organization);

    if (currentContentID && currentContentID !== undefined && s3Credentials) {
        //iterating over the file object
        for (let i = 0; i < fileObj.length; i++) {
            let file = fileObj[i];
            //uploading file to S3 server
            let response = yield call(Phi.Organization.uploadToS3, file, s3Credentials, currentContentID);

            if (response && response.headers && response.headers.location) {

                let docUrl = response.headers.location;
                let docContentIDPayload = {
                    contentJson: JSON.stringify({
                        content_url: docUrl.toString(),
                        type: category.toString(),
                        size: file.size,
                        file_name: file.name.toString(),
                        mimeType: file.type,
                        ...fileCustom
                    }),
                    userid: 1,
                    prefix: "HSG",
                    uuidFlag: "true"
                };

                //create contentId for the file uploaded
                let docContentID = yield call(Phi.Organization.addContentNode, Phi.Organization, docContentIDPayload);

                if (docContentID && docContentID.length) {

                    let payload = {
                        source_node_id: currentContentID.toString(),
                        target_node_id: docContentID[0].uuid.toString(),
                        relation_type_id: 6
                    };
                    //association of doc uploaded to the school
                    docUploadSuccess = yield call(Phi.Organization.addContentAssociation, Phi.Organization, {
                        inAssociationJson: JSON.stringify([payload])
                    });
                } else {
                    console.log("file contentId creation FAILED:::::", docContentID);
                }
            } else {
                console.log("file FAILED to upload to S3:::::", file);
            }

            docUploadSuccess && docUploadSuccess.status === 200
                ? console.log("FULL upload Done")
                : console.log("FULL upload FAILED");
            //console.log("association::::::::::", docUploadSuccess)
        }
    } else if (s3Credentials) {
        //if we don't have contentId for school/program
        let parentContentIDPayload = {
            contentJson: JSON.stringify({
                content_url: "",
                type: "main"
            }),
            userid: 1,
            prefix: "HSG",
            uuidFlag: "true"
        };

        //contentId for the school
        let parentContentIDResponse = yield call(
            Phi.Organization.addContentNode,
            Phi.Organization,
            parentContentIDPayload
        );

        if (parentContentIDResponse && parentContentIDResponse.length) {

            currentContentID = parentContentIDResponse[0].uuid;
            //setting up the contentId of school/program in store
            yield put(Actions.addContentID(currentContentID, fileGroup, uuid));

            //iterating over file Obj
            for (let i = 0; i < fileObj.length; i++) {
                let file = fileObj[i];
                //uploading file to S3
                let response = yield call(Phi.Organization.uploadToS3, file, s3Credentials, currentContentID);

                if (response && response.headers && response.headers.location) {

                    let docUrl = response.headers.location;
                    let docContentIDPayload = {
                        contentJson: JSON.stringify({
                            content_url: docUrl.toString(),
                            type: category.toString(),
                            size: file.size,
                            file_name: file.name.toString(),
                            mimeType: file.type,
                            ...fileCustom
                        }),
                        userid: 1,
                        prefix: "HSG",
                        uuidFlag: "true"
                    };

                    //creating contentId for the uploaded doc
                    let docContentID = yield call(
                        Phi.Organization.addContentNode,
                        Phi.Organization,
                        docContentIDPayload
                    );

                    if (docContentID && docContentID.length) {

                        let payload = {
                            source_node_id: parentContentIDResponse[0].uuid.toString(),
                            target_node_id: docContentID[0].uuid.toString(),
                            relation_type_id: 6
                        };

                        //associating uploaded file to school
                        docUploadSuccess = yield call(Phi.Organization.addContentAssociation, Phi.Organization, {
                            inAssociationJson: JSON.stringify([payload])
                        });
                    } else {
                        console.log("contentId creation FAILED:::::", docContentID);
                    }
                } else {
                    console.log("file FAILED to upload to S3:::::", file);
                }

                docUploadSuccess && docUploadSuccess.status === 200
                    ? console.log("FULL upload Done")
                    : console.log("FULL upload FAILED");
                console.log("association::::::::::", docUploadSuccess);
            }
        }
    }

    let contentIdObj = {
        contentId: currentContentID,
        fileGroup: fileGroup
    };

    Constants.showToaster("Saved", "INFO")

    //fetching all doc after uploading
    yield put(Actions.fetchDocuments(currentContentID, fileGroup));
}


// Saga Watcher
export function* watchMetadataActions() {
    yield* [
        takeLatest(Types.FETCH_COUNTRIES, fetchCountryList),
        takeEvery(Types.FETCH_STATES, fetchStateList),
        takeEvery(Types.FETCH_CITIES, fetchCityList),
        takeLatest(Types.FETCH_PARTNERS, fetchPartnerList),
        takeLatest(Types.FETCH_SPECIALITIES, fetchSpecialityList),
        takeLatest(Types.FETCH_OFFERS, fetchOffersList),
        takeEvery(Types.GET_GLOSSARY, getGlossary),

        // takeEvery(Types.FECTH_DOCUMENTS, fetchDocuments),
        // takeEvery(Types.UPLOAD_DOCUMENTS, uploadDocuments),
    ]
}